'use client'
import React from 'react'

export const AddIcon: React.FC = () => (
  <svg fill="none" height="20" viewBox="0 0 20 20" width="20" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 10h10" stroke="currentColor" />
    <path d="M10 15V5" stroke="currentColor" />
  </svg>
)
